import styles from './button.module.css'

/**
 * El peso del botón, de más a menos: relleno lleno, relleno teñido con borde, solo contorno, nada.
 *
 * `solid` es el default: un `<Button>` pelado es la acción que la vista existe para hacer. La
 * consecuencia es que un botón secundario se escribe entero —`tone="info" variant="outline"`— y eso
 * es a propósito: lo que no se escribe es lo que el componente promete por defecto.
 */
export type ButtonVariant = 'solid' | 'soft' | 'outline' | 'ghost'

export type ButtonSize = 'sm' | 'md' | 'lg'

/**
 * La clase de cada variante y de cada tamaño. Mapa y no plantilla: `Record<…>` obliga a que estén
 * todas, así que agregar un valor al union rompe acá y no en runtime. El default va con `''`
 * —`.au-btn` ya lo lleva— y decirlo así es distinto de omitirlo con un guard, que también taparía
 * una clase que falta. El porqué completo está en `tones.ts`.
 *
 * **Vive acá y no en `button.tsx` por lo mismo que `chip-badge.ts`**: son dos constantes que
 * comparten dos componentes —el `Button` y el `Toggle` con `look="button"`—, y una constante al
 * lado de un componente le rompe el fast-refresh (`react-refresh/only-export-components`).
 *
 * El `Toggle` no lee las cuatro: su eje son tres pesos, porque `solid` ya está en el techo del eje
 * y no le queda escalón para el estado encendido. El recorte lo declara su propio tipo, no este
 * mapa — acá el `Button` sigue necesitando las cuatro.
 */
export const VARIANT_CLASS: Record<ButtonVariant, string> = {
  solid: '',
  soft: styles['au-btn--soft'],
  outline: styles['au-btn--outline'],
  ghost: styles['au-btn--ghost'],
}

export const SIZE_CLASS: Record<ButtonSize, string> = {
  sm: styles['au-btn--sm'],
  md: '',
  lg: styles['au-btn--lg'],
}
